import { read_f32, read_i32, read_u16, read_u64, Sink } from "../../helpers/serializerHelpers";

export class InferredObjectTlvInfo {
    public id: bigint = BigInt(0);
    public confidence: number = 0;
    public x: number = 0;
    public y: number = 0;
    public width: number = 0;
    public height: number = 0;
    public classId: number = 0;
    public targetType: number = 0;

    public deserialize(bytes: Sink) {

        this.id = read_u64(bytes);
        this.x = read_f32(bytes);
        this.y = read_f32(bytes);
        this.width = read_f32(bytes);
        this.height = read_f32(bytes);
        this.classId = read_u16(bytes);
        this.targetType = read_i32(bytes);
        this.confidence = read_f32(bytes);
        return this;
    }
    public getLength() {
        return 8 + 4 + 4 + 4 + 4 + 4 + 2 + 4;
    }
}
